var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('router-link',{staticClass:"btn find-filled btn-margin-alert",attrs:{"to":{ name: 'professional.agenda.rules.index'}}},[_c('span',{staticClass:"icon"},[_vm._v("")]),_vm._v(" Cadastrar Agenda")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12f56545","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/professional/agenda/rules/components/alert-rules-agenda.vue
// module id = RGM4
// module chunks = 110